module.exports = __webpack_public_path__ + "img/compactar.3bfbe394.svg";